<template>
  <v-container>
    <base-card>
      <v-card-text>
        <v-card-title>
          <h1 class="text-h2"><span v-t="'Data confirmed successfully!'" /></h1>
        </v-card-title>
        <v-alert type="success">
          <div
            v-html="
              $t(
                'The data you\'ve entered has been successfully saved and forwarded to our employee. <br>We\'ll check your input and, if necessary, contact you to clarify.',
              )
            "
          />
        </v-alert>
        <SummaryTable />
      </v-card-text>
    </base-card>
  </v-container>
</template>

<script>
import SummaryTable from "../components/SummaryTable";
export default {
  components: {
    SummaryTable,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

